import React, { Component, PropTypes } from 'react';
import {Label, Button, Segment} from 'semantic-ui-react';
import {CopyToClipboard} from 'react-copy-to-clipboard'
import Highlight from 'react-highlight'
class CodeExample extends Component {

    render () {
        return this.renderLink();
    }

    renderLink () {
        const { text } = this.props;
        return (
            <Segment.Group>
                <Segment className="snippet">
                    <CopyToClipboard text={text}>
                        <Label floating as={Button}>Copy</Label>
                    </CopyToClipboard>
                    <Highlight className="bash">
                        {text}
                    </Highlight>
                </Segment>
            </Segment.Group>
    );
    }
}

CodeExample.propTypes = {
    text: PropTypes.string.isRequired,
};

export default CodeExample;

const codeExampleCloudFormationAssumeRole = `#!/bin/bash
aws cloudformation create-stack \\
    --stack-name envimation-assume-role-stack \\
    --template-url https://s3.eu-central-1.amazonaws.com/envi-developer-portal-site-prod/aws/envimation-assume-role.cloudformation.yml \\
    --capabilities CAPABILITY_NAMED_IAM \\
    --tags Key=TemplateSource,Value=https://envimation.com/getting-started Key=TemplateProduct,Value="CloudWatch envimation"
    `;

const codeExampleCliAssumeRole = `#!/bin/bash
aws iam create-role --role-name envimation-trust-role \\
    --description "envimation trust role" \\
    --assume-role-policy-document '{"Version":"2012-10-17","Statement":[{"Effect":"Allow","Principal":{"AWS":"arn:aws:iam::488006991244:root"},"Action":["sts:AssumeRole"]}]}'
aws iam attach-role-policy \\
    --role-name envimation-trust-role \\
    --policy-arn arn:aws:iam::aws:policy/AmazonEC2ReadOnlyAccess
aws iam attach-role-policy \\
    --role-name envimation-trust-role \\
    --policy-arn arn:aws:iam::aws:policy/CloudWatchFullAccess
aws iam attach-role-policy \\
    --role-name envimation-trust-role \\
    --policy-arn arn:aws:iam::aws:policy/CloudWatchLogsFullAccess`

export class CodeExampleCloudFormationAssumeRole extends Component {
    render() {
        return <CodeExample text={codeExampleCloudFormationAssumeRole}/>
    }
}

export class CodeExampleCliAssumeRole extends Component {
    render() {
            return <CodeExample text={codeExampleCliAssumeRole}/>
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/CodeExample/CodeExample.js
 **/